import { c as getElement, r as registerInstance, d as createEvent, h } from './index-34617187.js';
import { B as BxfInputMaskConstants, a as BxfInputTypeEnum, I as IMask, b as BxfMask } from './bxf-mask-c73e4b2e.js';
import { isEmpty, isNil } from 'lodash-es';
import { u as uuidv4 } from './uuidv4-06ebe3ff.js';
import { F as FocusSource } from './focus-source.enum-fe7089b3.js';
import { g as getValidator, i as isRequiredValidator } from './validator.factory-71476736.js';
import { B as BxfDefaultState } from './bxf-default-store-cc52e0b9.js';
import { H as HasPopupValue } from './has-popup-value.enum-d8e40cc4.js';
import { B as BxfFormValidationType } from './form-validation-type.enum-a74832c5.js';
import { B as BxfI18n, t as translateKeys, i as isUsingI18n } from './i18n.config-355137b0.js';
import { K as KeyboardEventKey } from './keyboard-event-key.enum-2f6c4d91.js';
import { A as BXF_MOUSE_FOCUS, Q as eventPath, l as createSelector, w as getKeyboardFocusCSS, z as BXF_ASSISTIVE_TEXT_HIDDEN } from './bxf-utils-3908c3c5.js';
import { c as computeContentWidth } from './bxf-text-input.utils-6d1dfc5c.js';
import { c as captureDefaultInputEvent } from './bxf-telemetry-utils-bf08318e.js';
import { R as Role } from './role.enum-c3c8cd89.js';
import { a as getAriaLabelledByForMaskedInput, u as useAriaLabelForAssistiveText } from './mask-assistive-text-69108aeb.js';
import { g as getAriaDescribedBy } from './get-aria-described-by-efcf0d0c.js';
import { r as renderSuccessMessage } from './render-success-message-181b3dcf.js';
import 'moment/moment';
import 'dompurify';

const bxfInputMaskCss = "button.sc-bxf-input-mask:hover,a.sc-bxf-input-mask:hover,input[type=radio].sc-bxf-input-mask:hover,input[type=checkbox].sc-bxf-input-mask:hover,input[type=radio].sc-bxf-input-mask:checked:hover,input[type=checkbox].sc-bxf-input-mask:checked:hover,svg.sc-bxf-input-mask:hover{cursor:pointer}svg[disabled].sc-bxf-input-mask:hover,button[disabled].sc-bxf-input-mask:hover,label[disabled].sc-bxf-input-mask:hover,input[type=checkbox].sc-bxf-input-mask:disabled:hover,input[type=radio].sc-bxf-input-mask:disabled:hover,input[type=checkbox].sc-bxf-input-mask:checked:disabled:hover,input[type=radio].sc-bxf-input-mask:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-input-mask{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.bxf-input-mask.sc-bxf-input-mask{display:flex;align-items:center;width:100%;box-sizing:border-box;height:2rem;border-radius:2px;caret-color:var(--primary-text__color);font-size:0.8125rem;text-align:left;font-family:inherit;border:solid 0.0625rem var(--form-element__border-color);background-color:var(--widget__background-color)}.bxf-input-mask.sc-bxf-input-mask::placeholder{color:var(--placeholder__color)}.bxf-input-mask.sc-bxf-input-mask:focus{outline:none}.bxf-input-mask__container.sc-bxf-input-mask{display:flex;flex-direction:column;width:100%;margin-bottom:-1px}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label.sc-bxf-input-mask,.bxf-input-mask__container.sc-bxf-input-mask .bxf-text-input__inner-section.sc-bxf-input-mask,.bxf-input-mask__container.sc-bxf-input-mask .bxf-select.sc-bxf-input-mask{flex:1}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label.sc-bxf-input-mask{display:inline-flex}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.sc-bxf-input-mask,.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left-error.sc-bxf-input-mask{flex:none}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.sc-bxf-input-mask{padding-right:0.75rem;align-items:center}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left-compact.sc-bxf-input-mask{padding-right:0.5rem}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.sc-bxf-input-mask .bxf-input-mask__label.sc-bxf-input-mask{padding-bottom:0}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.sc-bxf-input-mask .bxf-input-mask__label.sc-bxf-input-mask,.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.sc-bxf-input-mask .bxf-input-mask__label--required.sc-bxf-input-mask{line-height:2rem}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.bxf-input-mask-wrapper__label--compact.sc-bxf-input-mask .bxf-input-mask__label.sc-bxf-input-mask,.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.bxf-input-mask-wrapper__label--compact.sc-bxf-input-mask .bxf-input-mask__label--required.sc-bxf-input-mask{line-height:1.5rem}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.bxf-input-mask-wrapper__label--large.sc-bxf-input-mask{padding-top:0}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.bxf-input-mask-wrapper__label--large.sc-bxf-input-mask .bxf-input-mask__label.sc-bxf-input-mask,.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left.bxf-input-mask-wrapper__label--large.sc-bxf-input-mask .bxf-input-mask__label--required.sc-bxf-input-mask{line-height:2.5rem}.bxf-input-mask__container.sc-bxf-input-mask .bxf-input-mask-wrapper__label--left-instructional.sc-bxf-input-mask{align-items:flex-end}.bxf-input-mask__counter-container--left.sc-bxf-input-mask{display:flex;flex-direction:row}.bxf-input-mask-wrapper__label.sc-bxf-input-mask{display:inline-flex}.bxf-input-mask-wrapper__label--time-entry.sc-bxf-input-mask{display:inline-flex}.bxf-input-mask__label--left-val-message.sc-bxf-input-mask{padding-bottom:1.5rem}.bxf-input-mask-wrapper__label--left-time-entry-compact.sc-bxf-input-mask{padding-bottom:1.5rem}.bxf-input-mask__label--left-val-message--small.sc-bxf-input-mask{padding-bottom:1.25rem}.bxf-input-mask-wrapper__label--large.sc-bxf-input-mask{padding-top:0.75rem}.bxf-input-mask__label.sc-bxf-input-mask{display:inline-block;padding-bottom:0.5rem;font-size:0.8125rem;max-width:fit-content;min-width:fit-content;width:fit-content;color:var(--primary-text__color);flex:1;line-height:1.2307692308;white-space:nowrap}.bxf-input-mask__label--hidden.sc-bxf-input-mask{visibility:hidden}.bxf-input-mask__label--compact.sc-bxf-input-mask{padding-bottom:0.25rem}.bxf-input-mask__label--required.sc-bxf-input-mask,.bxf-input-mask__label--required-error.sc-bxf-input-mask,.bxf-input-mask__label--required-stacked.sc-bxf-input-mask,.bxf-input-mask__label--required-stacked-error.sc-bxf-input-mask{padding-left:0.25rem;color:var(--text__color--error);font-size:1rem}.bxf-input-mask__label--required.sc-bxf-input-mask{margin-bottom:auto;line-height:1.2307692308}.bxf-input-mask__label--required-error.sc-bxf-input-mask{margin-bottom:auto;line-height:1.2307692308}.bxf-input-mask__label--required-stacked.sc-bxf-input-mask{line-height:1.6}.bxf-input-mask__label--required-stacked-large.sc-bxf-input-mask{line-height:2.2}.bxf-input-mask__label--required-stacked-small.sc-bxf-input-mask{line-height:1.2}.bxf-input-mask__label--required-stacked-error.sc-bxf-input-mask{line-height:2.2}.bxf-input-mask__label--required-stacked-error-large.sc-bxf-input-mask{line-height:2.8}.bxf-input-mask__label--required-stacked-error-small.sc-bxf-input-mask{line-height:1.8}.input-mask-error-instructional.sc-bxf-input-mask{padding-bottom:1.25rem}.time-entry-error-instructional.sc-bxf-input-mask{padding-bottom:2.25rem}.bxf-input-mask-wrapper__label--left-error.sc-bxf-input-mask{padding:0 0.75rem 0 0;align-items:flex-start}.bxf-input-mask-wrapper__label--left-error-compact.sc-bxf-input-mask{padding-right:0.5rem}.bxf-input-mask-wrapper__label--left-error.sc-bxf-input-mask .bxf-input-mask__label.sc-bxf-input-mask{padding-bottom:0}.bxf-input-mask-wrapper__label--left-error.sc-bxf-input-mask .bxf-input-mask__label.sc-bxf-input-mask,.bxf-input-mask-wrapper__label--left-error.sc-bxf-input-mask .bxf-input-mask__label--required.sc-bxf-input-mask{line-height:2rem}.bxf-input-mask-wrapper__label--left-error.bxf-input-mask-wrapper__label--compact.sc-bxf-input-mask .bxf-input-mask__label.sc-bxf-input-mask,.bxf-input-mask-wrapper__label--left-error.bxf-input-mask-wrapper__label--compact.sc-bxf-input-mask .bxf-input-mask__label--required.sc-bxf-input-mask{line-height:1.5rem}.bxf-input-mask-wrapper__label--left-error.bxf-input-mask-wrapper__label--large.sc-bxf-input-mask{padding-top:0}.bxf-input-mask-wrapper__label--left-error.bxf-input-mask-wrapper__label--large.sc-bxf-input-mask .bxf-input-mask__label.sc-bxf-input-mask,.bxf-input-mask-wrapper__label--left-error.bxf-input-mask-wrapper__label--large.sc-bxf-input-mask .bxf-input-mask__label--required.sc-bxf-input-mask{line-height:2.5rem}.bxf-input-mask-wrapper__label--left-error-instructional.sc-bxf-input-mask{align-items:flex-end}.bxf-input-mask__label--left.sc-bxf-input-mask{flex-direction:row}.bxf-input-mask__label--left-inline.sc-bxf-input-mask{display:flex;justify-content:space-between}.bxf-input-mask__character-counter.sc-bxf-input-mask{color:var(--placeholder__color);padding-bottom:0.5rem;font-size:0.8125rem;line-height:1.2307692308;width:100%;text-align:right}.bxf-input-mask__character-counter--instructional.sc-bxf-input-mask{width:auto;padding-left:0.5rem}.bxf-text-input__inner-section.sc-bxf-input-mask{flex:auto}.bxf-text-input__inner-section--inline.sc-bxf-input-mask{flex:0}.bxf-text-input__inner-section.sc-bxf-input-mask:focus{outline:none}.bxf-input-mask--fit-content.sc-bxf-input-mask{width:fit-content}.bxf-input-mask--focused.bxf-input-mask--focused-keyboard.sc-bxf-input-mask,.bxf-input-mask--focused-keyboard.bxf-input-mask--focused-combo.sc-bxf-input-mask{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-input-mask--focused.bxf__mouse-focus.sc-bxf-input-mask,.bxf__mouse-focus.bxf-input-mask--focused-combo.sc-bxf-input-mask{background-color:var(--focus-highlight_background-color);border-color:var(--focus-highlight_border-color);border-bottom:solid 0.0625rem var(--input__border-bottom-color_focus);outline:none;caret-color:var(--input-caret__color)}.bxf-input-mask--focused.bxf-input-mask--readonly.sc-bxf-input-mask,.bxf-input-mask--readonly.bxf-input-mask--focused-combo.sc-bxf-input-mask{color:var(--primary-text__color)}.bxf-input-mask--focused-combo.sc-bxf-input-mask{border-bottom-color:var(--focus-highlight_border-color)}.bxf-input-mask__prepend.sc-bxf-input-mask{padding:0 0 0 0.75rem;height:100%;display:flex;align-items:center;justify-content:center;color:var(--primary-text__color)}.bxf-input-mask__prepend.disabled.sc-bxf-input-mask{color:var(--disabled-text__color)}.bxf-input-mask__input.sc-bxf-input-mask{border:0;background-color:transparent;color:var(--primary-text__color);font:inherit;flex:1 1 0;min-width:0;overflow:hidden;padding:0 0.75rem;height:100%}.bxf-input-mask__input.sc-bxf-input-mask::placeholder{color:var(--placeholder__color);font-style:normal;font-size:0.8125rem;line-height:1.2307692308}.bxf-input-mask__input.sc-bxf-input-mask:focus{outline:none}.bxf-input-mask__input.sc-bxf-input-mask:focus::placeholder{color:transparent}.bxf-input-mask__input.sc-bxf-input-mask:disabled{color:var(--disabled-text__color)}.bxf-input-mask__input.sc-bxf-input-mask:disabled::placeholder{color:var(--placeholder__color--disabled)}.bxf-input-mask__input.populated.sc-bxf-input-mask{color:var(--primary-text__color)}.bxf-input-mask__input--placeholder-color.sc-bxf-input-mask{color:var(--placeholder__color)}.bxf-input-mask__input--placeholder-color.bxf-input-mask--readonly.sc-bxf-input-mask{color:var(--primary-text__color)}.bxf-input-mask__append.sc-bxf-input-mask{padding-left:0;padding-right:0.75rem;height:100%;display:flex;align-items:center;justify-content:center;color:var(--primary-text__color)}.bxf-input-mask__append.sc-bxf-input-mask:hover{cursor:pointer}.bxf-input-mask__append.disabled.sc-bxf-input-mask{color:var(--disabled-text__color)}.bxf-input-mask__append.disabled.sc-bxf-input-mask:hover{cursor:default}.bxf-input-mask__append--editable.sc-bxf-input-mask{border:none;background-color:transparent}.bxf-input-mask__append--editable.sc-bxf-input-mask:focus{outline:none}.bxf-input-mask__append--editable.sc-bxf-input-mask:focus bxf-icon.sc-bxf-input-mask{outline:0.0625rem dotted var(--primary-action__color);outline:auto var(--primary-action__color)}.bxf-input-mask__append--editable.sc-bxf-input-mask:focus.bxf__focus--keyboard-only:not(:focus-visible) bxf-icon.sc-bxf-input-mask{outline:none}.bxf-input-mask--error.sc-bxf-input-mask,.bxf-input-mask--focused.bxf-input-mask--error.sc-bxf-input-mask,.bxf-input-mask--error.bxf-input-mask--focused-combo.sc-bxf-input-mask{border:solid 0.0625rem var(--form-element__border-color--error);background-color:var(--form-element__background-color--error)}.bxf-input-mask--warning.sc-bxf-input-mask,.bxf-input-mask--focused.bxf-input-mask--warning.sc-bxf-input-mask,.bxf-input-mask--warning.bxf-input-mask--focused-combo.sc-bxf-input-mask{border:solid 0.0625rem var(--form-element__border-color--warning);background-color:var(--form-element__background-color--warning)}.bxf-input-mask--success.sc-bxf-input-mask,.bxf-input-mask--focused.bxf-input-mask--success.sc-bxf-input-mask,.bxf-input-mask--success.bxf-input-mask--focused-combo.sc-bxf-input-mask{border:solid 0.0625rem var(--form-element__border-color--success);background-color:var(--form-element__background-color--success)}.bxf-input-mask--disabled.sc-bxf-input-mask,.bxf-input-mask--readonly.sc-bxf-input-mask,.bxf-input-mask--focused.bxf-input-mask--readonly.sc-bxf-input-mask,.bxf-input-mask--readonly.bxf-input-mask--focused-combo.sc-bxf-input-mask{color:var(--disabled-text__color);border:solid 0.0625rem transparent;background-color:var(--input-box__background-color--disabled)}.bxf-input-mask--disabled.sc-bxf-input-mask::placeholder,.bxf-input-mask--readonly.sc-bxf-input-mask::placeholder,.bxf-input-mask--focused.bxf-input-mask--readonly.sc-bxf-input-mask::placeholder,.bxf-input-mask--readonly.bxf-input-mask--focused-combo.sc-bxf-input-mask::placeholder{color:var(--placeholder__color--disabled)}.bxf-input-mask--disabled.sc-bxf-input-mask svg.sc-bxf-input-mask:hover,.bxf-input-mask--readonly.sc-bxf-input-mask svg.sc-bxf-input-mask:hover{cursor:default}.bxf-input-mask--readonly.sc-bxf-input-mask{color:var(--primary-text__color)}.bxf-input-mask__label--disabled.sc-bxf-input-mask{color:var(--disabled-text__color)}.bxf-input-mask__message.sc-bxf-input-mask,.bxf-input-mask__message--success.sc-bxf-input-mask,.bxf-input-mask__message--warning.sc-bxf-input-mask,.bxf-input-mask__message--error.sc-bxf-input-mask{display:inline-block;font-size:0.8125rem;line-height:1.2307692308;padding-top:0.25rem}.bxf-input-mask__message--error.sc-bxf-input-mask{color:var(--text__color--error)}.bxf-input-mask__message--success.sc-bxf-input-mask{color:var(--text__color--success)}.bxf-input-mask--compact.sc-bxf-input-mask{height:1.5rem;font-size:0.75rem}.bxf-input-mask--compact.sc-bxf-input-mask .bxf-input-mask__label--left.sc-bxf-input-mask{line-height:1.5rem}.bxf-input-mask--large.sc-bxf-input-mask{height:2.5rem}.bxf-input-mask--large.sc-bxf-input-mask .bxf-input-mask__label--left.sc-bxf-input-mask{line-height:2.5rem}input[type=number].sc-bxf-input-mask::-webkit-inner-spin-button,input[type=number].sc-bxf-input-mask::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}button.sc-bxf-input-mask:disabled{border:0;background-color:var(--input-box__background-color--disabled)}.bxf-input-mask--no-left-padding.sc-bxf-input-mask>.bxf-input-mask__input.sc-bxf-input-mask{padding-left:0}.bxf-input-mask--no-right-padding.sc-bxf-input-mask>.bxf-input-mask__input.sc-bxf-input-mask{padding-right:0}.bxf-input-mask__instructional-text.sc-bxf-input-mask{color:var(--secondary-text__color);font-size:0.8125rem;padding-bottom:0.5rem;line-height:1.2307692308}.bxf-input-mask__instructional-text--counter.sc-bxf-input-mask{display:flex;justify-content:space-between;align-items:flex-end}.bxf-input-mask__instructional-text--compact.sc-bxf-input-mask{padding-bottom:0.25rem}@media (forced-colors: active){.bxf-input-mask.sc-bxf-input-mask{border-color:ButtonBorder}.bxf-input-mask--disabled.sc-bxf-input-mask,.bxf-input-mask--focused.bxf-input-mask--readonly.sc-bxf-input-mask,.bxf-input-mask--readonly.bxf-input-mask--focused-combo.sc-bxf-input-mask,.bxf-input-mask--readonly.sc-bxf-input-mask{border-color:GrayText;color:GrayText}.bxf-input-mask--readonly.sc-bxf-input-mask{border-color:ButtonBorder;color:initial}.bxf-input-mask--focused.bxf-input-mask--focused-keyboard.sc-bxf-input-mask,.bxf-input-mask--focused-keyboard.bxf-input-mask--focused-combo.sc-bxf-input-mask{border-color:Highlight;outline-color:Highlight}.bxf-input-mask--focused.bxf__mouse-focus.sc-bxf-input-mask,.bxf__mouse-focus.bxf-input-mask--focused-combo.sc-bxf-input-mask{border-color:Highlight}.bxf-input-mask__label--disabled.sc-bxf-input-mask,.bxf-input-mask__append.disabled.sc-bxf-input-mask,.bxf-input-mask__prepend.disabled.sc-bxf-input-mask,.bxf-input-mask__input.disabled.sc-bxf-input-mask,.bxf-input-mask.sc-bxf-input-mask .disabled.sc-bxf-input-mask .bxf-icon__container.sc-bxf-input-mask{color:GrayText}.bxf-input-mask__append--editable.sc-bxf-input-mask:focus bxf-icon.sc-bxf-input-mask{outline-color:Highlight}.bxf-input-mask__input--populated-color.sc-bxf-input-mask{color:GrayText}.bxf-input-mask__input--populated-color.bxf-input-mask--readonly.sc-bxf-input-mask{color:initial}.bxf-input-mask__label.disabled.sc-bxf-input-mask,.bxf-input-mask__appended-string.disabled.sc-bxf-input-mask,.bxf-input-mask__prepended-string.disabled.sc-bxf-input-mask{color:GrayText}.bxf-input-mask__container.disabled.sc-bxf-input-mask{border-color:GrayText}.bxf-input-mask__container--keyboard-focused.sc-bxf-input-mask{border-color:Highlight;outline-color:Highlight}.bxf-input-mask__stepper-container.sc-bxf-input-mask{border-left-color:Canvas}.bxf-input-mask__container--focused.bxf-input-mask__focus-element.sc-bxf-input-mask{border-color:Highlight}}";
const BxfInputMaskStyle0 = bxfInputMaskCss;

const { PREPEND, DISABLED, PREFIX_EDITABLE, PREFIX_FOCUSED, INPUT_MASK, DISABLED_INPUT, READONLY_INPUT, SMALL, COMPACT_THEME, LARGE, LARGE_THEME, INPUT_MASK_ERROR, INPUT_MASK_WARNING, INPUT_MASK_SUCCESS, INPUT_MASK_FOCUSED, INPUT_MASK_KEY_FOCUSED, COMBO, FIT_CONTENT, INPUT_MASK_INPUT_BOX, INPUT_MASK_INPUT_PLACEHOLDER_COLOR, APPEND, SUFFIX_EDITABLE, SUFFIX_FOCUSED, ERROR_MESSAGE, WARNING_MESSAGE, SUCCESS_MESSAGE, INPUT_MASK_CONTAINER, LEFT_LABEL, LEFT_LABEL_INSTRUCTIONAL_MESSAGE, LEFT_LABEL_INSTRUCTIONAL_MESSAGE_SMALL, INPUT_MASK_INNER_SECTION, INPUT_MASK_REQUIRED, CHARACTER_COUNTER, CHARACTER_COUNTER_INSTRUCTIONAL, INPUT_MASK_COUNTER_CONTAINER_LEFT, DISABLED_LABEL, HIDDEN_LABEL, INPUT_MASK_LABEL, LABEL_COMPACT_THEME, LABEL_LARGE_THEME, INPUT_MASK_LABEL_WRAPPER_LEFT_INSTRUCTIONAL, INPUT_MASK_LABEL_WRAPPER_LEFT, INPUT_MASK_LABEL_WRAPPER, LEFT_LABEL_VALIDATION_MESSAGE, LEFT_LABEL_VALIDATION_MESSAGE_SMALL, INPUT_MASK_LABEL_WRAPPER_TIME_ENTRY, TIME_ENTRY_INSTRUCTIONAL, INPUT_MASK_ERROR_INSTRUCTIONAL, INPUT_MASK_LABEL_WRAPPER_LEFT_ERROR, ERROR_SUFFIX, SMALL_SUFFIX, LARGE_SUFFIX, HOST, DOCUMENT, LEFT, SIZE, BOX_CONTAINER, LABEL_CONTAINER, PREFIX_CONTAINER, SUFFIX_BUTTON, SUFFIX_INERT, REMOVE_LEFT_PADDING, REMOVE_RIGHT_PADDING, INPUT_MASK_INNER_SECTION_INLINE, LEFT_LABEL_INLINE, INPUT_MASK_LABEL_COMPACT, INPUT_MASK_LABEL_WRAPPER_LEFT_COMPACT, INPUT_MASK_REQUIRED_STACKED, } = BxfInputMaskConstants.STRING;
const BxfInputMask = class {
    /**
     * This event is emitted on change of value inside text input for form validation
     */
    formValueChanged;
    /**
     * This event is emitted on change of value inside text input
     */
    valueChanged;
    /**
     * This event is emitted on focus change of text input
     */
    focusChanged;
    /**
     * This event is emitted on blur change of text input
     */
    blurChanged;
    /**
     * This event emits the raw value without the mask
     */
    rawValueChanged;
    /**
     * This event emits the click event when prefix is clicked.
     */
    prefixClicked;
    /**
     * This event emits the click event when suffix is clicked.
     */
    suffixClicked;
    _labelId = uuidv4();
    _errorMsgId = uuidv4();
    _prefixId = uuidv4();
    _suffixId = uuidv4();
    _descriptionId = uuidv4();
    _charCounterId = uuidv4();
    _validator;
    _mask;
    _blurredElement;
    _inputContainerRef;
    _prefixRef;
    _suffixRef;
    _currencyRegex = new RegExp(/^\d{1,3}(?:,?\d{3})*(\.\d{6})?/);
    _contactRegex = new RegExp(/^\(?\d{3}\)?\d{3}-?\d{4}/);
    _numberRegex = new RegExp(/^\d+/);
    _timeEntry12HourRegex = new RegExp(/^(?:0?\d|1[0-2])[-:][0-5]\d\s*[AP]M/);
    _timeEntry24HourRegex = new RegExp(/^(?:[01]\d|2[0-3])[-:h][0-5]\d/);
    DISPLAY_MASKS = [
        BxfInputMaskConstants.DISPLAY_MASKS.CONTACT,
        BxfInputMaskConstants.DISPLAY_MASKS.TIME_ENTRY_12_HOUR,
        BxfInputMaskConstants.DISPLAY_MASKS.TIME_ENTRY_24_HOUR,
    ];
    // _isInitialRender should only be used in lifecycle methods.
    // Used to ensure valueChanged/rawValueChanged is not emitted on initial render
    _isInitialRender = true;
    _value;
    _charCounterInitialMaxLen;
    _isInternalMaxLenSet = false;
    _charCounterMax;
    _allowedTypesForCounter = [
        BxfInputTypeEnum.NUMBER,
        BxfInputTypeEnum.CURRENCY,
        BxfInputTypeEnum.TEXT,
    ];
    i18n;
    _hasPaddingBottom = false;
    _allowNegativeNumbers = false;
    // Stores the cursor position for use when updating an overwrite mask value
    _overwriteMaskCursorPosition = 0;
    // Used to skip the value watcher after updating the cursor position for overwrite masks.
    _skipValueWatcher = false;
    _skipValueWatcherAfterNextUpdate = false;
    // Custom cursor logic for overwrite masks is only needed when the user updates the field via the text box
    _updatedFromTextInput = false;
    /**
     * A list of masks with overwrite set to true. This is used to handle custom value prop update logic.
     * @private
     */
    OVERWRITE_MASKS = [
        BxfInputTypeEnum.CONTACT,
        BxfInputTypeEnum.TIME_ENTRY_24_HOUR,
        BxfInputTypeEnum.TIME_ENTRY_12_HOUR,
    ];
    /**
     * For masks with overwrite set to true, we want to skip the placeholder chars when updating cursor position.
     * @private
     */
    OVERWRITE_PLACEHOLDER_CHARS = ['(', ':', '-', ')'];
    // Used to ensure valueChanged/rawValueChanged is not emitted when it is a type change
    fromTypeChange = false;
    textInputElement;
    errorMessageElement;
    get host() { return getElement(this); }
    /**
     * Public method that sets value for forms
     */
    async setValue(newValue) {
        if (isEmpty(newValue)) {
            this.clearValue();
            return;
        }
        let updatedValue = newValue;
        // Remove commas from count for currency masks
        if (this.type === BxfInputTypeEnum.CURRENCY) {
            updatedValue = newValue.replace(',', '');
        }
        this.updateValueProp(updatedValue);
    }
    /**
     * Public method that toggles disable for forms
     */
    async toggleDisable(action) {
        this.isDisabled = action;
    }
    /**
     * Public method that checks if value is invalid when used for required validation in forms
     */
    async validateForRequired(newValue) {
        // should return true if value is not provided and required validator should return error
        return Promise.resolve(this.invalidValueValidator(newValue));
    }
    /**
     * Public method that toggles rendering input box with focused styling except the bottom border
     */
    async toggleBlurComboStyle() {
        if (this.isFocused) {
            this.isFocused = false;
        }
        this.hasComboStyle = !this.hasComboStyle;
    }
    /**
     * Public method that renders input box with focused styling
     */
    async focusInput() {
        this.isFocused = true;
        this.toggleFocusSource(FocusSource.Mouse);
        this.textInputElement?.focus();
    }
    /**
     * Public method that returns reference to the prefix container
     */
    async getPrefixRef() {
        return this._prefixRef;
    }
    /**
     * Public method that returns reference to the suffix container
     */
    async getSuffixRef() {
        return this._suffixRef;
    }
    /**
     * Public method that returns reference to the input box container.
     * This container includes prefix, input, and suffix. Header Label and error message are excluded
     */
    async getInputContainerRef() {
        return this._inputContainerRef;
    }
    /**
     * Public method that clears current value and reset it to mask
     */
    async clearValue() {
        this.value = '';
        return Promise.resolve(true);
    }
    /**
     * Public method that validates value
     */
    async validate() {
        const value = this._mask ? this._value : this.value;
        if (this.validator) {
            this._validator = getValidator(this.validator);
            this.isValid = this._validator.validate(value);
            if (this._validator?.errorMessage) {
                this.errorMessage = this._validator.errorMessage;
            }
        }
    }
    charCounterWatcher(newValue) {
        if (newValue) {
            this.handleCharCounter();
        }
    }
    allowNegativeNumbersWatcher(newValue, oldValue) {
        if (this.type === 'number' && newValue !== oldValue) {
            this._allowNegativeNumbers = newValue;
            if (this._mask) {
                this._mask.destroy();
            }
            this.initMask(this.value);
        }
    }
    maxLengthWatcher(newValue) {
        if (Number.isInteger(newValue) && this.isCounterAllowed) {
            this.value =
                newValue > 0 && this.value?.length > newValue
                    ? this.value.substring(0, newValue)
                    : this.value;
            if (!this._isInternalMaxLenSet) {
                this.handleCharCounter();
            }
            else {
                this._isInternalMaxLenSet = false;
            }
        }
        else {
            this.maxLength = this.isTimeEntry ? this.maxLength : undefined;
        }
    }
    typeHandler() {
        this.fromTypeChange = true;
        this.isCounterAllowed = this._allowedTypesForCounter.includes(BxfInputTypeEnum[this.type.toUpperCase()]);
        if (this._mask && this.type !== this._mask.type) {
            this._mask.destroy();
        }
        this.initMask();
        this.handleCharCounter();
        if (this.value) {
            this.maskHandler(this.value);
        }
        else {
            this.updateWidth();
        }
    }
    valueWatcher(newValue, oldValue) {
        if (this._updatedFromTextInput && this._skipValueWatcher) {
            this._skipValueWatcher = false;
            return;
        }
        if (newValue === oldValue || (!newValue && !this._mask)) {
            return;
        }
        let value = newValue;
        /**
         * When the reset button is clicked in a faceted filter option that contains text input elements
         * that have an input mask, newValue is set to null, so we need to turn newValue into the empty
         * string so that the input elements will reset to their empty initial values
         */
        if (!value) {
            value = '';
        }
        // Remember the cursor position. We have to force this so the cursor does not jump to the end of the value
        const cursorPosition = this.textInputElement.selectionStart;
        const distanceToEnd = value.length - cursorPosition;
        this.updateValueProp(value);
        this.updateCursorPosition(cursorPosition, distanceToEnd);
    }
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.formValueChanged = createEvent(this, "formValueChanged", 7);
        this.valueChanged = createEvent(this, "valueChanged", 7);
        this.focusChanged = createEvent(this, "focusChanged", 7);
        this.blurChanged = createEvent(this, "blurChanged", 7);
        this.rawValueChanged = createEvent(this, "rawValueChanged", 7);
        this.prefixClicked = createEvent(this, "prefixClicked", 7);
        this.suffixClicked = createEvent(this, "suffixClicked", 7);
        this.value = '';
        this.type = BxfInputTypeEnum.CONTACT;
        this.validator = undefined;
        this.label = undefined;
        this.instructionalText = undefined;
        this.assistiveText = '';
        this.placeholder = undefined;
        this.isLeftLabel = false;
        this.isCompact = BxfDefaultState.isCompact;
        this.isLabelHidden = false;
        this.allowNegativeNumbers = false;
        this.size = SIZE;
        this.isStackedLeftLabel = false;
        this.maxLength = undefined;
        this.showCharacterCount = false;
        this.maskOptions = undefined;
        this.prefixLabel = undefined;
        this.suffixLabel = undefined;
        this.prefixIcon = undefined;
        this.suffixIcon = undefined;
        this.suffixAssistiveText = '';
        this.suffixHasPopup = HasPopupValue.FALSE;
        this.isSuffixExpanded = undefined;
        this.isPrefixEditable = false;
        this.isSuffixEditable = false;
        this.matchContentWidth = false;
        this.textAlign = LEFT;
        this.hasComboStyle = false;
        this.blurredElement = undefined;
        this.eventData = {};
        this.isRequired = false;
        this.isDisabled = false;
        this.isReadOnly = false;
        this.errorMessage = null;
        this.isSuccess = false;
        this.successMessage = null;
        this.validationType = BxfFormValidationType.ERROR;
        this.isValid = true;
        this.isTracking = true;
        this.trackingData = undefined;
        this.dataTestSuffix = undefined;
        this.keepMouseFocus = false;
        this.step = 1;
        this.removeLeftPadding = false;
        this.removeRightPadding = false;
        this.emitValueChangedOnClear = false;
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.isTimeEntry = false;
        this.isFocused = false;
        this.isMaskEmpty = true;
        this.focusSource = undefined;
        this.hasKeyboardFocus = false;
        this.isCounterAllowed = false;
        this.mouseDownHandler = this.mouseDownHandler.bind(this);
        this.touchStartHandler = this.touchStartHandler.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.onBlurChangeHandler = this.onBlurChangeHandler.bind(this);
        this.onSuffixClickedHandler = this.onSuffixClickedHandler.bind(this);
        this.onInputFocus = this.onInputFocus.bind(this);
        this.onInputHandler = this.onInputHandler.bind(this);
        this.iconClickHandler = this.iconClickHandler.bind(this);
    }
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
    }
    componentWillLoad() {
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        this.isCounterAllowed = this._allowedTypesForCounter.includes(BxfInputTypeEnum[this.type.toUpperCase()]);
        this.allowNegativeNumbersWatcher(this.allowNegativeNumbers, false);
        this.isCounterAllowed = this._allowedTypesForCounter.includes(BxfInputTypeEnum[this.type.toUpperCase()]);
        if (!isEmpty(this.value) && this.isValid) {
            this.validate();
        }
        this.handleCharCounter();
        if (!this.blurredElement) {
            this.blurredElement = DOCUMENT;
            this._blurredElement = document;
        }
        else if (this.blurredElement === HOST) {
            this._blurredElement = this.host;
        }
        else {
            this._blurredElement = document;
        }
    }
    disconnectedCallback() {
        this.i18n?.destroyTranslations();
    }
    componentDidLoad() {
        this.initMask(this.value);
        this._value = this.value;
        this.updateWidth();
        this._isInitialRender = false;
        this.adjustPaddingForAlignment();
    }
    componentWillUpdate() {
        this._charCounterMax =
            this.isCounterAllowed && this.showCharacterCount && this.maxLength
                ? this._charCounterInitialMaxLen
                : undefined;
    }
    componentDidUpdate() {
        if (!this._mask && this.textInputElement) {
            this.initMask();
            this.updateWidth();
        }
        this.adjustPaddingForAlignment();
    }
    /**
     * Toggle mouse styling on mouse click
     */
    mouseDownHandler() {
        this.toggleFocusSource(FocusSource.Mouse);
    }
    /**
     * Toggle mouse styling on touch press
     */
    /* istanbul ignore next: touchstart fires mousedown, see ADO-1255700 */
    touchStartHandler() {
        this.toggleFocusSource(FocusSource.Touch);
    }
    /**
     * Toggle focus ring on tab
     */
    keyDownHandler(event) {
        if (event.key === KeyboardEventKey.Tab) {
            this.toggleFocusSource(FocusSource.Keyboard);
        }
    }
    /**
     * Updates the value property. Will force the mask value to update if needed.
     * @param newValue
     */
    updateValueProp(newValue) {
        // Truncate the value if it exceeds maxLength
        let updatedValue = newValue;
        if (this.maxLength &&
            this.isCounterAllowed &&
            updatedValue.length > this.maxLength) {
            updatedValue = updatedValue.substring(0, this.maxLength);
        }
        // Update the value
        if (this._mask) {
            this._mask.forceValue(updatedValue);
            const updatedMaskValue = this._mask.value;
            this.value = updatedMaskValue;
            this.maskHandler(updatedMaskValue);
        }
        else {
            this.value = updatedValue;
            this.maskHandler(updatedValue);
        }
    }
    /**
     * Function that updates the cursor position following a value update.
     * @private
     */
    updateCursorPosition(cursorPosition, distanceToEnd) {
        // Masks with overwrite set to true require custom logic for cursor position updates
        if (this.OVERWRITE_MASKS.includes(this.type)) {
            // If the next char after the cursor is a placeholder char, skip it
            const nextChar = this.value.charAt(cursorPosition);
            this._overwriteMaskCursorPosition =
                this.OVERWRITE_PLACEHOLDER_CHARS.includes(nextChar)
                    ? cursorPosition + 1
                    : cursorPosition;
            if (this._skipValueWatcherAfterNextUpdate) {
                this._skipValueWatcherAfterNextUpdate = false;
                // Set the skipValueWatcher flag so the value will not be cleared following the cursor update.
                this._skipValueWatcher = true;
                this.textInputElement.setSelectionRange(this._overwriteMaskCursorPosition, this._overwriteMaskCursorPosition);
            }
        }
        else {
            const newCursorPosition = this._mask.value.length - distanceToEnd;
            this.textInputElement.setSelectionRange(newCursorPosition, newCursorPosition);
        }
    }
    /**
     * Function that handles when input value is changed.
     */
    onInputHandler(event) {
        const newValue = event.target['value'];
        // For currency masks, do not update value if more than 2 digits after decimal
        if (this.type === BxfInputTypeEnum.CURRENCY &&
            /\.\d{3,}$/.test(newValue)) {
            return;
        }
        if (this.OVERWRITE_MASKS.includes(this.type)) {
            /**
             * For overwrite masks, do not update if the user enters a value after the last char which would cause the value
             * to exceed the length of the display mask. This prevents the value prop from allowing an extra char
             */
            if (this.textInputElement.selectionStart === newValue.length &&
                this._mask.displayMask &&
                newValue.length > this._mask.displayMask.length) {
                return;
            }
            /**
             * For overwrite masks, iMask tries to clear the value after the cursor. Set the _skipValueWatcherAfterNextUpdate
             * flag to true so the component does not pick up this change following the cursor update. The value watcher
             * immediately sets this flag to false so functionality will continue as normal. The workflow is:
             * 	=> User updates the value via the text box
             * 	=> the value prop is updated within the value watcher, skipValueWatcher flag set to true
             * 	=> the cursor position is persisted
             * 	=> iMask tries to clear the value after the cursor, but the skipValueWatcher flag prevents this
             * 	=> skipValueWatcher flag reset back to false
             */
            this._skipValueWatcherAfterNextUpdate = true;
        }
        this._updatedFromTextInput = true;
        this.value = newValue;
        this._updatedFromTextInput = false;
        if (this.value &&
            this.textInputElement.classList.contains(INPUT_MASK_INPUT_PLACEHOLDER_COLOR)) {
            this.textInputElement.classList.remove(INPUT_MASK_INPUT_PLACEHOLDER_COLOR);
        }
        else if (!this.value) {
            this.textInputElement.classList.add(INPUT_MASK_INPUT_PLACEHOLDER_COLOR);
        }
    }
    /**
     * Whether or not component focused via mouse
     * Note: if keepMouseFocus enabled, this always returns false
     */
    get isMouseFocus() {
        return (!this.keepMouseFocus &&
            (this.focusSource === FocusSource.Mouse ||
                this.focusSource === FocusSource.Touch));
    }
    /**
     * Focus styling for mouse vs keyboard
     */
    get focusSourceCss() {
        return this.isMouseFocus ? BXF_MOUSE_FOCUS : '';
    }
    /**
     * Public getter that creates instructional text css
     * @returns {string}
     */
    get instructionalTextCss() {
        const { INSTRUCTIONAL_TEXT, INSTRUCTIONAL_TEXT_COUNTER, INSTRUCTIONAL_TEXT_COMPACT, } = BxfInputMaskConstants.STRING;
        const instructionalCounter = this.isCounterAndLeftLabel
            ? INSTRUCTIONAL_TEXT_COUNTER
            : '';
        const isCompact = this.isCompact ? INSTRUCTIONAL_TEXT_COMPACT : '';
        return `${INSTRUCTIONAL_TEXT} ${instructionalCounter} ${isCompact}`.trim();
    }
    leftLabelStyles() {
        let isLeftLabelVal = '';
        let isLeftLabelInstructional = '';
        if ((this.isValid && this.successMessage) ||
            (!this.isValid && this.errorMessage)) {
            isLeftLabelVal =
                this.size === SMALL
                    ? LEFT_LABEL_VALIDATION_MESSAGE_SMALL
                    : LEFT_LABEL_VALIDATION_MESSAGE;
        }
        if (this.instructionalText) {
            isLeftLabelInstructional =
                this.size === SMALL
                    ? LEFT_LABEL_INSTRUCTIONAL_MESSAGE_SMALL
                    : LEFT_LABEL_INSTRUCTIONAL_MESSAGE;
        }
        return { isLeftLabelVal, isLeftLabelInstructional };
    }
    getLeftLabelStyles() {
        let isLeftErrorAndInstructional = '';
        let isTimeEntryLeftErrorAndInstructional = '';
        let inputMaskLabelWrapper = INPUT_MASK_LABEL_WRAPPER;
        const isSuccessOrError = (this.isValid && this.successMessage) ||
            (!this.isValid && this.errorMessage);
        const leftLabelStyles = this.leftLabelStyles();
        const isLeftLabelInstructionalMessage = leftLabelStyles.isLeftLabelInstructional;
        const isLeftLabelValMessage = !this.instructionalText
            ? leftLabelStyles.isLeftLabelVal
            : '';
        const isLeftLabel = !isSuccessOrError || this.instructionalText
            ? INPUT_MASK_LABEL_WRAPPER_LEFT
            : INPUT_MASK_LABEL_WRAPPER_LEFT_ERROR;
        if (this.isTimeEntry) {
            isTimeEntryLeftErrorAndInstructional =
                isSuccessOrError && this.instructionalText
                    ? TIME_ENTRY_INSTRUCTIONAL
                    : '';
            inputMaskLabelWrapper = INPUT_MASK_LABEL_WRAPPER_TIME_ENTRY;
        }
        else {
            isLeftErrorAndInstructional =
                isSuccessOrError && this.instructionalText
                    ? INPUT_MASK_ERROR_INSTRUCTIONAL
                    : '';
        }
        return `${inputMaskLabelWrapper} ${isLeftLabel} ${isLeftLabelValMessage} ${isLeftLabelInstructionalMessage} ${isLeftErrorAndInstructional} ${isTimeEntryLeftErrorAndInstructional}`.trim();
    }
    /**
     * Public getter that creates label's wrapper text css
     * @returns {string}
     */
    get labelWrapperCss() {
        const smallTheme = this.size === SMALL ? LABEL_COMPACT_THEME : '';
        const largeTheme = this.size === LARGE ? LABEL_LARGE_THEME : '';
        let inputMaskLabelWrapper = INPUT_MASK_LABEL_WRAPPER;
        let leftLabelStyles = '';
        let isInstructional = '';
        let isCompact = '';
        if (this.isLeftLabel) {
            inputMaskLabelWrapper = '';
            leftLabelStyles = this.getLeftLabelStyles();
            isInstructional = this.instructionalText
                ? INPUT_MASK_LABEL_WRAPPER_LEFT_INSTRUCTIONAL
                : '';
            isCompact = this.isCompact
                ? INPUT_MASK_LABEL_WRAPPER_LEFT_COMPACT
                : '';
        }
        return `${inputMaskLabelWrapper} ${leftLabelStyles} ${isCompact} ${isInstructional} ${smallTheme} ${largeTheme}`.trim();
    }
    /**
     * Public getter that creates label text css
     * @returns {string}
     */
    get labelCss() {
        const disabled = this.isDisabled ? DISABLED_LABEL : '';
        const isLabelHidden = this.isLabelHidden ? HIDDEN_LABEL : '';
        const isCompact = this.isCompact ? INPUT_MASK_LABEL_COMPACT : '';
        return `${INPUT_MASK_LABEL} ${isCompact} ${isLabelHidden} ${disabled}`;
    }
    /**
     * Toggle focus source to given value.
     * If value is not keyboard, only change value if keepMouseFocus off
     */
    toggleFocusSource(focusSource) {
        if (focusSource === FocusSource.Keyboard) {
            this.focusSource = FocusSource.Keyboard;
        }
        else if (!this.keepMouseFocus) {
            this.focusSource = focusSource;
        }
    }
    /**
     * Function checks all the conditions for which value should be invalid
     */
    invalidValueValidator(newValue) {
        const validators = {
            [BxfInputTypeEnum.CONTACT]: () => !this._contactRegex.test(newValue),
            [BxfInputTypeEnum.TIME_ENTRY_12_HOUR]: () => !this._timeEntry12HourRegex.test(newValue),
            [BxfInputTypeEnum.TIME_ENTRY_24_HOUR]: () => !this._timeEntry24HourRegex.test(newValue),
            [BxfInputTypeEnum.NUMBER]: () => !this._numberRegex.test(newValue),
            [BxfInputTypeEnum.CURRENCY]: () => !this._currencyRegex.test(newValue),
        };
        const validator = validators[BxfInputTypeEnum[this.type.toUpperCase()]];
        return validator ? validator.call(this) : isNil(newValue);
    }
    /**
     * Function to set maxLength and determine character counter
     */
    handleCharCounter() {
        // in most of the types maxLength and character counter shouldn't be used
        if (this.isCounterAllowed) {
            /* istanbul ignore else */
            if (this.showCharacterCount && this.maxLength) {
                this._charCounterMax = this.maxLength;
                this._charCounterInitialMaxLen = this._charCounterMax;
                if (this._charCounterMax &&
                    this.value.length > this._charCounterMax) {
                    this.value = this.value.substring(0, this._charCounterMax);
                }
            }
            else if (this.maxLength && this.value.length > this.maxLength) {
                this.value = this.value.substring(0, this.maxLength);
            }
        }
        else {
            this.maxLength = this.isTimeEntry ? this.maxLength : undefined;
            this._charCounterMax = undefined;
        }
    }
    /**
     * Whether or not to emit the valueChanged event on empty (or placeholder) value
     */
    shouldEmitEmptyValueChanged(value) {
        if (this.emitValueChangedOnClear) {
            const typeChange = this.fromTypeChange;
            this.fromTypeChange = false;
            return ((!value || this.DISPLAY_MASKS.includes(value)) && !typeChange);
        }
        return false;
    }
    _valueHandler() {
        this.validate();
        this.updateWidth();
        if (!this._isInitialRender &&
            (!this.invalidValueValidator(this._value) ||
                this.shouldEmitEmptyValueChanged(this._value))) {
            this.valueChanged.emit({
                value: this._value,
                eventData: this.eventData,
                srcEvent: null,
            });
        }
        // Emitting the unmasked value
        if (this._mask && typeof this._mask.getUnmaskedValue === 'function') {
            // Form value changed must be emitted on initial render for validation to work for contact masks
            if (!this._isInitialRender ||
                this.type === BxfInputTypeEnum.CONTACT) {
                this.formValueChanged.emit({
                    value: this._mask.value,
                });
            }
            if (!this._isInitialRender) {
                this.rawValueChanged.emit({
                    value: this._mask.getUnmaskedValue(),
                    eventData: this.eventData,
                    srcEvent: null,
                });
            }
        }
    }
    _setValue(newValue = '') {
        if (this._value !== newValue) {
            this._value = newValue;
            this._valueHandler();
        }
    }
    _setMaskedValue() {
        let displayMask = '';
        if (!isEmpty(this._mask)) {
            displayMask = this._mask.displayMask
                ? this._mask.displayMask
                : displayMask;
        }
        this._setValue(displayMask);
    }
    toggleEmptyMask() {
        this.isMaskEmpty =
            !this._value ||
                /^[tT]/.test(this._value) ||
                !/\d/.test(this._value);
    }
    handleContactMask() {
        return {
            mask: BxfInputMaskConstants.MASKS.CONTACT, // (123)456-7890
            placeholderChar: '_',
            lazy: false,
            overwrite: true,
        };
    }
    handleCurrencyMask() {
        return {
            mask: Number, // enable number mask
            // other options are optional with defaults below
            scale: 2, // digits after point, 0 for integers
            min: 0, // disallow negative
            thousandsSeparator: ',', // any single char
            padFractionalZeros: false, // if true, then pads zeros at end to the length of scale
            normalizeZeros: false, // appends or removes zeros at ends
            radix: '.', // fractional delimiter
            mapToRadix: ['.'], // symbols to process as radix
        };
    }
    handleNumberMask() {
        return {
            mask: Number,
            scale: 2,
            min: this._allowNegativeNumbers ? Number.MIN_SAFE_INTEGER : 0,
            thousandsSeparator: '',
            padFractionalZeros: false,
            normalizeZeros: false,
            radix: '.',
            mapToRadix: [],
            prepare: (str) => {
                if (str === '-0') {
                    return '-';
                }
                return str;
            },
        };
    }
    handleTimeEntryMask(is24HourFormat = true) {
        const { TIME_ENTRY_12_HOUR, TIME_ENTRY_24_HOUR } = BxfInputMaskConstants.MASKS;
        return {
            mask: is24HourFormat ? TIME_ENTRY_24_HOUR : TIME_ENTRY_12_HOUR,
            autofix: false,
            lazy: false,
            overwrite: true,
            prepareChar: (str) => {
                return str.toUpperCase();
            },
            blocks: {
                HH: {
                    mask: IMask.MaskedRange,
                    placeholderChar: 'H',
                    from: is24HourFormat ? 0 : 1,
                    to: is24HourFormat ? 23 : 12,
                    maxLength: 2,
                },
                MM: {
                    mask: IMask.MaskedRange,
                    placeholderChar: 'M',
                    from: 0,
                    to: 59,
                    maxLength: 2,
                },
                Z: {
                    mask: '#M',
                    lazy: false,
                    placeholderChar: 'A',
                    definitions: {
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        '#': /[AaPp]/,
                    },
                },
            },
        };
    }
    maskSorter() {
        const maskHandlers = {
            [BxfInputTypeEnum.CONTACT]: this.handleContactMask,
            [BxfInputTypeEnum.TIME_ENTRY_12_HOUR]: () => this.handleTimeEntryMask(false),
            [BxfInputTypeEnum.TIME_ENTRY_24_HOUR]: this.handleTimeEntryMask,
            [BxfInputTypeEnum.NUMBER]: this.handleNumberMask,
            [BxfInputTypeEnum.CURRENCY]: this.handleCurrencyMask,
        };
        const handler = maskHandlers[BxfInputTypeEnum[this.type.toUpperCase()]];
        return handler ? handler.call(this) : { mask: /.*/ };
    }
    getMaskOptions() {
        if (!isEmpty(this.maskOptions)) {
            return {
                ...this.maskOptions,
            };
        }
        return this.maskSorter();
    }
    initMask(initialValue) {
        if (!this.textInputElement) {
            return;
        }
        this._mask = new BxfMask(this.textInputElement, this.getMaskOptions(), isEmpty(this.maskOptions) ? this.type : '', (value) => this.maskHandler(value), initialValue);
        this._setMaskedValue();
    }
    maskHandler(value) {
        this._setValue(value);
        this.toggleEmptyMask();
    }
    setWidth(width) {
        if (width && this._numberRegex.test(width)) {
            this.textInputElement.style.width = width;
            if (this.errorMessageElement && this._inputContainerRef) {
                this.errorMessageElement.style.width = `${Math.max(width, this._inputContainerRef.offsetWidth)}px`;
            }
        }
    }
    updateWidth(value = this._value || this.placeholder) {
        if (isEmpty(value)) {
            this._setMaskedValue();
        }
        else if (this.matchContentWidth && this.textInputElement) {
            const width = computeContentWidth(value, 1.15);
            // Set the width on the input element
            this.setWidth(width);
        }
    }
    onPrefixClickedHandler(event) {
        if (this.isPrefixEditable && !this.isDisabled) {
            this.prefixClicked.emit({
                srcEvent: event,
                eventData: this.eventData,
            });
        }
    }
    onSuffixClickedHandler(event) {
        if (this.isSuffixEditable && !this.isDisabled) {
            this.suffixClicked.emit({
                srcEvent: event,
                eventData: this.eventData,
            });
        }
    }
    /**
     * Private function that handles while input in blur.
     */
    onBlurChangeHandler(event) {
        this.hasKeyboardFocus = false;
        event.preventDefault();
        if (eventPath(event).find((el) => el === this._blurredElement)) {
            if (this.isFocused) {
                this.isFocused = false;
            }
            this.validate();
            const ev = this.blurChanged.emit({
                value: this.textInputElement.value,
                srcEvent: event,
                eventData: this.eventData,
            });
            captureDefaultInputEvent(ev);
        }
    }
    /**
     * Private function that handles while input in focus.
     */
    onFocusChangeHandler(event, fromSection = false) {
        event.preventDefault();
        if (!this.isFocused) {
            this.isFocused = true;
        }
        this.textInputElement.setSelectionRange(0, this.textInputElement.value.length);
        if (fromSection) {
            this.focusChanged.emit({
                value: this.textInputElement.value,
                srcEvent: event,
                eventData: this.eventData,
            });
        }
    }
    /**
     * Handle keyboard focus for text input
     */
    onInputFocus(event) {
        this.clickHandler(event);
        this.hasKeyboardFocus = true;
    }
    /**
     * Private function that handles when input box is clicked.
     */
    clickHandler(event) {
        if (!this.isFocused && !this.isDisabled) {
            this.onFocusChangeHandler(event, true);
        }
    }
    /**
     * Render screen reader only assistive text
     */
    renderAssistiveText(hasId) {
        return (h("span", { id: hasId ? this._labelId : null, class: BXF_ASSISTIVE_TEXT_HIDDEN }, this.assistiveText));
    }
    /**
     * Private function to get the character counter text depending on type of input mask
     * When input mask type is either Number or Currency character counter should ignore '.', '-', and ',' characters
     */
    getCounterText() {
        const isNumberOrCurr = BxfInputTypeEnum[this.type.toUpperCase()] ===
            BxfInputTypeEnum.NUMBER ||
            BxfInputTypeEnum[this.type.toUpperCase()] ===
                BxfInputTypeEnum.CURRENCY;
        let counterText;
        let value = this._value;
        if (value && isNumberOrCurr) {
            value = value.replace('-', '').replace(/\./g, '').replace(/,/g, '');
            const nonDigitsLength = this._value.length - value.length;
            const newMaxLen = this._charCounterInitialMaxLen + nonDigitsLength;
            if (newMaxLen !== this.maxLength) {
                this._isInternalMaxLenSet = true;
                this.maxLength = newMaxLen;
            }
            counterText = `${value.length || '0'}/${this._charCounterInitialMaxLen}`;
        }
        else {
            counterText = `${value ? value.length : '0'}/${this._charCounterInitialMaxLen}`;
        }
        return counterText;
    }
    /**
     * Gets the character counter HTML element
     */
    getCounterHtmlEl() {
        const counterText = this.getCounterText();
        return (h("div", { class: CHARACTER_COUNTER, id: this._charCounterId }, counterText));
    }
    isInputRequired() {
        return this.isRequired || isRequiredValidator(this.validator);
    }
    getErrorSuffix() {
        let errorSuffix = '';
        if (!this.instructionalText) {
            errorSuffix =
                (!this.isValid && this.errorMessage) ||
                    (this.isValid && this.successMessage)
                    ? ERROR_SUFFIX
                    : '';
        }
        return errorSuffix;
    }
    getAsteriskClass() {
        let label = INPUT_MASK_REQUIRED;
        let errorSuffix = '';
        if (this.isLeftLabel) {
            label = INPUT_MASK_REQUIRED_STACKED;
            errorSuffix = this.getErrorSuffix();
            if (this.size === SMALL) {
                return `${label}${errorSuffix} ${INPUT_MASK_REQUIRED_STACKED}${errorSuffix}${SMALL_SUFFIX}`.trim();
            }
            if (this.size === LARGE) {
                return `${label}${errorSuffix} ${INPUT_MASK_REQUIRED_STACKED}${errorSuffix}${LARGE_SUFFIX}`.trim();
            }
            return `${label}${errorSuffix} ${INPUT_MASK_REQUIRED_STACKED}${errorSuffix}`.trim();
        }
        return `${label}${errorSuffix}`.trim();
    }
    getAsteriskEl() {
        return this.isInputRequired() && this.label ? (h("div", { class: this.getAsteriskClass(), "aria-hidden": 'true' }, "*")) : null;
    }
    renderLabelWrapperDiv() {
        const hasLabel = !!this.label;
        const asterisk = this.getAsteriskEl();
        const charCounter = this._charCounterMax
            ? this.getCounterHtmlEl()
            : null;
        const instructionalText = !this.isLeftLabel && !this.instructionalText && !this.isCompact
            ? { paddingBottom: `${7.75 / 16}rem` }
            : null;
        return (h("div", { class: this.labelWrapperCss, "data-test": createSelector(this.host.tagName, LABEL_CONTAINER) }, h("div", { id: this._labelId, class: this.labelCss, style: instructionalText }, hasLabel ? this.label : this.renderAssistiveText()), hasLabel ? asterisk : '', this.isLeftLabel ? '' : charCounter));
    }
    /**
     * Private function that handles label for text input container
     */
    renderLabelContainer() {
        if (this.label ||
            this._charCounterMax ||
            isRequiredValidator(this.validator)) {
            return this.renderLabelWrapperDiv();
        }
        if (!this.useAriaLabel()) {
            return this.renderAssistiveText(true);
        }
        return null;
    }
    getInnerSectionCss() {
        return `${INPUT_MASK_INNER_SECTION} ${this.isStackedLeftLabel ? INPUT_MASK_INNER_SECTION_INLINE : ''}`.trim();
    }
    /**
     * Return error and success message wrapped in live region
     * 	so that screen reader reads out messages as field is validated
     */
    renderSuccessErrorMessage() {
        return (h("div", { id: this._errorMsgId, role: Role.ALERT, "aria-atomic": 'true' }, this.renderErrorMessage(), this.renderSuccessMessage()));
    }
    /**
     * Gets the inner div in the input area HTML element
     */
    getInputInnerHtmlEl() {
        return (h("div", { class: this.getInnerSectionCss() }, this.renderInstructionalText(), h("div", { class: this.inputCss(), ref: (el) => {
                this._inputContainerRef = el;
            }, "data-test": createSelector(this.host.tagName, BOX_CONTAINER) }, this.renderPrefix(), this.renderInputBox(), this.renderSuffix()), this.renderSuccessErrorMessage()));
    }
    /**
     * Renders the character counter on top of input
     */
    renderCharCounter() {
        const shouldHaveCharCounterRow = !!this.label && this.isLeftLabel;
        if (this._charCounterMax && shouldHaveCharCounterRow) {
            return this.getCounterHtmlEl();
        }
        return null;
    }
    /**
     * Renders input area differently based on left label and character counter
     */
    renderInputArea() {
        if (this.isCounterAndLeftLabel) {
            return (h("div", { class: INPUT_MASK_COUNTER_CONTAINER_LEFT }, this.renderLabelContainer(), this.getInputInnerHtmlEl()));
        }
        return this.getInputInnerHtmlEl();
    }
    /**
     * Renders the character counter when in the same div with instructional text
     */
    renderInstructionalCounter() {
        const counterText = this.getCounterText();
        const counterInstructionalCss = `${CHARACTER_COUNTER} ${CHARACTER_COUNTER_INSTRUCTIONAL}`;
        return (h("div", { class: counterInstructionalCss, id: this._charCounterId }, counterText));
    }
    renderInstructionalText() {
        const instructionalTextCss = this.instructionalText
            ? this.instructionalTextCss
            : null;
        return (h("div", { class: instructionalTextCss, style: { minHeight: `${0.25 / 16}rem` } }, h("span", { id: this._descriptionId }, this.instructionalText), this.isCounterAndLeftLabel
            ? this.renderInstructionalCounter()
            : ''));
    }
    /**
     * Private function that handles prefix label
     */
    renderPrefixLabel() {
        if (this.prefixLabel && !this.prefixIcon) {
            return h("span", { id: this._prefixId }, this.prefixLabel);
        }
        return null;
    }
    /**
     * Private function that handles prefix icon
     */
    renderPrefixIcon() {
        if (this.prefixIcon) {
            return (h("bxf-icon", { type: this.prefixIcon, state: 'secondary', isDisabled: this.isDisabled || this.isReadOnly, dataTestSuffix: createSelector('00', this.dataTestSuffix, true) }));
        }
        return null;
    }
    /**
     * Private function that handles prefix inside text input
     */
    renderPrefix() {
        if (this.prefixIcon || this.prefixLabel) {
            const css = `${PREPEND} ${this.isDisabled ? DISABLED : ''} ${this.isPrefixEditable && !this.isDisabled ? PREFIX_EDITABLE : ''} ${this.hasComboStyle ? PREFIX_FOCUSED : ''}`;
            return (h("div", { class: css, ref: (el) => {
                    this._prefixRef = el;
                }, "data-test": createSelector(this.host.tagName, PREFIX_CONTAINER), onClick: (event) => this.onPrefixClickedHandler(event), onMouseDown: this.iconClickHandler }, this.renderPrefixLabel(), this.renderPrefixIcon()));
        }
        return null;
    }
    /**
     * Private function that creates input css.
     */
    inputCss() {
        return {
            [INPUT_MASK]: true,
            [DISABLED_INPUT]: this.isDisabled,
            [READONLY_INPUT]: this.isReadOnly,
            [COMPACT_THEME]: this.size === SMALL,
            [LARGE_THEME]: this.size === LARGE,
            [INPUT_MASK_ERROR]: !this.isValid &&
                this.validationType === BxfFormValidationType.ERROR,
            [INPUT_MASK_WARNING]: !this.isValid &&
                this.validationType === BxfFormValidationType.WARNING,
            [INPUT_MASK_SUCCESS]: this.isValid && this.isSuccess && !isEmpty(this.successMessage),
            [INPUT_MASK_FOCUSED]: this.isFocused,
            [INPUT_MASK_KEY_FOCUSED]: this.hasKeyboardFocus,
            [COMBO]: this.hasComboStyle,
            [FIT_CONTENT]: this.matchContentWidth,
            [BXF_MOUSE_FOCUS]: this.isMouseFocus,
            [REMOVE_LEFT_PADDING]: this.removeLeftPadding,
            [REMOVE_RIGHT_PADDING]: this.removeRightPadding,
        };
    }
    inputBoxCss() {
        const placeholderColor = this.isMaskEmpty
            ? `${INPUT_MASK_INPUT_PLACEHOLDER_COLOR}`
            : '';
        const readonlyCSS = this.isReadOnly ? READONLY_INPUT : '';
        return `${INPUT_MASK_INPUT_BOX} ${placeholderColor} ${readonlyCSS}`;
    }
    inputRefHandler(el) {
        if (el) {
            this.textInputElement = el;
            this.updateWidth();
        }
    }
    get leftCss() {
        if (this.size === 'large') {
            return LEFT_LABEL;
        }
        if (this.size === 'small') {
            return LEFT_LABEL;
        }
        return LEFT_LABEL;
    }
    /**
     * Private function that creates container css string.
     * @returns {string}
     */
    get containerCss() {
        const charCounter = this._charCounterMax ? '' : this.leftCss;
        const isLeftLabel = this.isLeftLabel ? charCounter : '';
        return `${INPUT_MASK_CONTAINER} ${isLeftLabel} ${this.isStackedLeftLabel ? LEFT_LABEL_INLINE : ''}`.trim();
    }
    errorRefHandler(el) {
        if (el) {
            this.errorMessageElement = el;
            this.updateWidth();
        }
    }
    /**
     * Get aria-labelledby for text field per the following guidelines:
     *  Label should read <label> <prefix label> <suffix label>
     */
    getAriaLabelledBy() {
        if (this.useAriaLabel())
            return null;
        return getAriaLabelledByForMaskedInput(this._labelId, this._prefixId, this._suffixId, this.prefixLabel, this.suffixLabel, this.prefixIcon, this.suffixIcon);
    }
    /**
     * Return assistive text if aria label should be used
     */
    getAriaLabel() {
        return this.useAriaLabel() ? this.assistiveText : null;
    }
    /**
     * Whether to use aria-label or aria-labelledby
     */
    useAriaLabel() {
        return useAriaLabelForAssistiveText(this.label, this.prefixLabel, this.suffixLabel, this.suffixIcon, this.isSuffixEditable);
    }
    /**
     * Returns value for aria-described-by attribute
     */
    getAriaDescribedBy() {
        return getAriaDescribedBy(this.instructionalText, this._descriptionId, this._charCounterMax, this._charCounterId);
    }
    /**
     * Private function that handles text input
     */
    renderInputBox() {
        const style = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            'text-align': this.textAlign || 'right',
        };
        return (h("input", { ref: (el) => this.inputRefHandler(el), type: 'text', class: this.inputBoxCss(), step: this.type === 'number' ? this.step : null, style: style, placeholder: this.placeholder, disabled: this.isDisabled, readOnly: this.isReadOnly, maxLength: this.maxLength, "aria-describedby": this.getAriaDescribedBy(), "aria-invalid": `${!this.isValid}`, "aria-errormessage": this.isValid || !this.errorMessage ? null : this._errorMsgId, "aria-label": this.getAriaLabel(), "aria-labelledby": this.getAriaLabelledBy(), "aria-required": `${this.isInputRequired()}`, onFocus: this.onInputFocus, onBlur: this.onBlurChangeHandler, onMouseDown: this.mouseDownHandler, onKeyDown: this.keyDownHandler, onInput: this.onInputHandler, onTouchStart: this.touchStartHandler }));
    }
    /**
     * Private function that handles suffix label
     */
    renderSuffixLabel() {
        if (this.suffixLabel && !this.suffixIcon) {
            return h("span", { id: this._suffixId }, this.suffixLabel);
        }
        return null;
    }
    /**
     * Private function that handles suffix icon
     */
    renderSuffixIcon() {
        if (this.suffixIcon) {
            return (h("bxf-icon", { type: this.suffixIcon, state: 'secondary', isDisabled: this.isDisabled || this.isReadOnly, dataTestSuffix: createSelector('01', this.dataTestSuffix, true) }));
        }
        return null;
    }
    /**
     * Render suffix label or icon
     */
    renderSuffixContent() {
        return [this.renderSuffixLabel(), this.renderSuffixIcon()];
    }
    /**
     * Get styling for suffix icon/button
     */
    get suffixCss() {
        const baseCss = `${APPEND} ${this.isDisabled ? DISABLED : ''} ${this.isSuffixEditable && !this.isDisabled ? SUFFIX_EDITABLE : ''} ${this.hasComboStyle ? SUFFIX_FOCUSED : ''}`;
        return getKeyboardFocusCSS(baseCss, this.keepMouseFocus);
    }
    /**
     * Get assistive label for suffix icon button
     */
    get suffixButtonAriaLabel() {
        return this.suffixLabel ? null : this.suffixAssistiveText;
    }
    /**
     * Get if left label and character counter props are truthy
     */
    get isCounterAndLeftLabel() {
        return this.isLeftLabel && this._charCounterMax !== undefined;
    }
    /**
     * Combine click and mousedown handlers
     */
    iconClickHandler(event) {
        this.clickHandler(event);
    }
    /**
     * Render suffix as button
     */
    renderSuffixButton() {
        return (h("button", { class: this.suffixCss, ref: (el) => {
                this._suffixRef = el;
            }, "aria-hidden": this.isDisabled ? 'true' : null, "aria-label": this.suffixButtonAriaLabel, "aria-haspopup": this.suffixHasPopup, "aria-expanded": this.isSuffixExpanded === undefined
                ? null
                : `${this.isSuffixExpanded}`, onClick: this.onSuffixClickedHandler, onBlur: this.onBlurChangeHandler, onMouseDown: this.iconClickHandler, disabled: this.isDisabled || this.isReadOnly, "data-test": createSelector(this.host.tagName, SUFFIX_BUTTON) }, this.renderSuffixContent()));
    }
    /**
     * Render suffix as inert div
     */
    renderInertSuffix() {
        return (h("div", { class: this.suffixCss, ref: (el) => {
                this._suffixRef = el;
            }, "data-test": createSelector(this.host.tagName, SUFFIX_INERT), onMouseDown: this.iconClickHandler }, this.renderSuffixContent()));
    }
    /**
     * Private function that handles suffix with label and icon.
     *  - If the suffix should be clickable, render a button.
     *  - Otherwise, render inert div.
     */
    renderSuffix() {
        if (this.suffixIcon || this.suffixLabel) {
            if (this.isSuffixEditable) {
                return this.renderSuffixButton();
            }
            return this.renderInertSuffix();
        }
        return null;
    }
    /**
     * Render error message
     */
    renderErrorMessage() {
        if (!this.isValid && this.errorMessage) {
            return (h("span", { ref: (el) => this.errorRefHandler(el), class: this.validationType === BxfFormValidationType.ERROR
                    ? ERROR_MESSAGE
                    : WARNING_MESSAGE }, this.errorMessage));
        }
        return null;
    }
    /**
     * Private function that handles success message
     */
    renderSuccessMessage() {
        return renderSuccessMessage(this.isValid, this.isSuccess, this.successMessage, SUCCESS_MESSAGE);
    }
    getLabelElement() {
        let labelElement;
        if (this.isTimeEntry) {
            labelElement = this.host.querySelector(`.${INPUT_MASK_LABEL_WRAPPER_TIME_ENTRY}`);
        }
        else {
            labelElement = this.host.querySelector(`.${INPUT_MASK_LABEL_WRAPPER}`);
        }
        return labelElement;
    }
    setLabelPaddingBottom(labelElement, errorElement) {
        if (((this.errorMessage && !this.isValid) ||
            (this.successMessage && this.isValid)) &&
            this.instructionalText) {
            const heightDifference = Number(errorElement.clientHeight);
            if (heightDifference > 0) {
                labelElement.style.paddingBottom = `${Math.abs(heightDifference)}px`;
                this._hasPaddingBottom = true;
            }
        }
    }
    adjustPaddingForAlignment() {
        const labelElement = this.getLabelElement();
        const errorElement = this.host.querySelector(`.${ERROR_MESSAGE}`);
        if (labelElement && errorElement) {
            if (this.isLeftLabel) {
                this.setLabelPaddingBottom(labelElement, errorElement);
            }
            else if (this._hasPaddingBottom) {
                labelElement.style.paddingBottom = '0';
                this._hasPaddingBottom = false;
            }
        }
    }
    render() {
        return (h("div", { key: 'a48c43ad1feebc380f6632bc7d6aff78d68a9791', class: this.containerCss, "data-test": createSelector(this.host.tagName, this.dataTestSuffix) }, this._charCounterMax && !this.instructionalText
            ? this.renderCharCounter()
            : '', this.isCounterAndLeftLabel ? '' : this.renderLabelContainer(), this.renderInputArea()));
    }
    static get watchers() { return {
        "showCharacterCount": ["charCounterWatcher"],
        "allowNegativeNumbers": ["allowNegativeNumbersWatcher"],
        "maxLength": ["maxLengthWatcher"],
        "type": ["typeHandler"],
        "value": ["valueWatcher"]
    }; }
};
BxfInputMask.style = BxfInputMaskStyle0;

export { BxfInputMask as bxf_input_mask };
